import { render, staticRenderFns } from "./AdminSocietiesListView.vue?vue&type=template&id=f0e8d93e&scoped=true"
import script from "./AdminSocietiesListView.vue?vue&type=script&lang=js"
export * from "./AdminSocietiesListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e8d93e",
  null
  
)

export default component.exports